<template>
  <Wrapper class="q-px-lg q-py-xl">
    <h5 class="q-mb-xl">Operation City & Price Set</h5>

    <div class="bg-gray q-pa-sm q-mb-md">
      <q-btn flat color="primary" label="Add city" icon="add" @click="isAddCityDialogOpen = true" />
    </div>

    <DataTable :columns="columns">
      <tr v-for="item in list" :key="item.id">
        <td>{{ item.id | formatId }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.rfqSentPrice | formatCurrency }}</td>
        <td>{{ item.bookingReceivedPrice | formatCurrency }}</td>
        <td>{{ item.commissionRate | formatCommissionRate }}</td>
        <td>{{ item.subscriptionPrice | formatCurrency }}</td>
        <td>{{ item.updatedAt | formatDate }}</td>
        <td><span class="action" @click="selectedCity = item">Change</span></td>
      </tr>
    </DataTable>

    <AddCityDialog v-if="isAddCityDialogOpen" :is-open.sync="isAddCityDialogOpen" @created="debouncedFetchCities" />

    <ModifyCityPriceDialog v-if="selectedCity" :city.sync="selectedCity" @updated="debouncedFetchCities" />
  </Wrapper>
</template>

<script>
import _debounce from 'lodash/debounce';
import Wrapper from '@/components/Wrapper.vue';
import DataTable from '@/components/DataTableNew.vue';
import API from '@/apis';

export default {
  components: {
    Wrapper,
    DataTable,
    AddCityDialog: () => import('./OperationPrice/AddCityDialog.vue'),
    ModifyCityPriceDialog: () => import('./OperationPrice/ModifyCityPriceDialog.vue'),
  },

  filters: {
    formatCommissionRate(val) {
      return `${val.toFixed(2)}%`;
    },
  },

  data() {
    return {
      list: [],
      isAddCityDialogOpen: false,
      selectedCity: null,
      citySelected: null,
      columns: [
        'ID',
        'City',
        'RFQ Sent',
        'Booking Received',
        'Commission',
        'Bubscription',
        'Last Modified',
        'Operation',
      ],
    };
  },

  created() {
    this.debouncedFetchCities = _debounce(this.fetchCities, 500);
    this.fetchCities();
  },

  methods: {
    async fetchCities() {
      const { data } = await this.$axios.request(API.city.getAll());
      this.list = data.data;
    },
  },
};
</script>
